<template>
  <div class="component component--fullscreen" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="vip">
      <div class="component__containter" v-if="componentVisible" ref="containter">
        <div class="vip">
          <button class="vip-close" v-on:click="closeVIP()"><i class="material-icons">clear</i></button>
          <div class="vip-header">
            <div class="vip-name">{{ vip.name }}</div>
            <div class="vip-fig"><img :src="vip.image_card"></div>
          </div>
          <div class="vip-body">
            <div class="section-title">{{ $t('profile.desc') }}</div>
            <div class="desc" v-html="vip.goods"></div>
            <div class="section-title">{{ $t('profile.condition') }}</div>
            <div class="condition" v-html="vip.condition"></div>
            <div class="section-title" v-if="expire">{{ $t('profile.expire') }}</div>
            <div class="expire" v-if="expire" v-html="expire.duration_str"></div>
            <div class="expire" v-if="expire" v-html="expire.progress_str"></div>
            <div class="section-title" v-if="upgrade">{{ $t('profile.upgrade') }}</div>
            <div class="upgrade-list" v-if="upgrade">
              <div class="upgrade-item"
                v-for="vip in upgrade"
                :key="vip.name"
              >
                <div class="upgrade-icon">
                  <i class="material-icons">subdirectory_arrow_right</i>
                </div>
                <div class="upgrade-content">
                  <div class="upgrade-title">{{ vip.name }}</div>
                  <div class="section-title" v-if="upgrade">{{ $t('profile.upgradeCondition') }}</div>
                  <div>{{ vip.condition_str }}</div>
                  <div class="section-title" v-if="upgrade">{{ $t('profile.upgradeProgress') }}</div>
                  <div>{{ vip.progress_str }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Axios from '@/helpers/axios';

export default {
  name: 'VIP-Detail',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
    vip: {
      type: Object,
      required: true,
    },
    current: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      componentVisible: false,
      expire: null,
      upgrade: null,
    };
  },
  watch: {
    visable(value) {
      this.expire = null;
      this.upgrade = null;

      this.$nextTick(() => {
        this.componentVisible = value;
      });

      if (value) {
        this.$gtm.trackEvent({
          event: '查看會員資格詳情',
          label: `${this.$root.$store.state.brand.name} - ${this.vip.name}`,
        });

        if (this.current) {
          const data = {
            lang: this.$i18n.locale,
            p: this.$parent.client.phoneType,
            brand_id: this.$route.params.brand,
            dtk: this.$parent.client.dtk,
            _vip: this.vip.idx,
          };

          Axios({
            method: 'post',
            url: '/ocard/vip',
            data,
          })
            .then((response) => {
              if (response.data.code === 500) {
                this.expire = response.data.data.expire_info;
                this.upgrade = response.data.data.upgrade_info;
              }
            });
        }
      }
    },
  },
  methods: {
    closeVIP() {
      this.$emit('closeVIP');
    },
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1050
  padding-top: 50vh
  margin: 0 auto
  overflow: auto
  -webkit-overflow-scrolling: touch

  @media only screen and (min-width : 768px)
    max-width: 500px

.vip
  position: relative
  padding: 12px 16px
  min-height: calc(100vh - 54px)

  border-radius: 16px 16px 0 0

  background-color: white

  &-close
    position: absolute
    top: 12px
    right: 12px
    padding: 8px
    width: 40px
    height: 40px

    border: none
    border-radius: 12px

    background-color: #F1F1F1

    color: #909090

    outline: none

    &:active
      color: #333

  &-name
    font-weight: bold
    font-size: 1rem
    text-align: center
    line-height: 40px

  &-fig
    margin: 8px 8px 0
    padding-bottom: 24px

    border-bottom: 1px solid rgba(0, 0, 0, .1)

    text-align: center

    img
      height: 100px
      border-radius: 10px

.section-title
  margin: 24px 8px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

.desc,
.condition,
.expire,
.upgrade
  font-size: 0.875rem
  color: #8E8E8E

.desc,
.condition
  white-space: pre-wrap

.upgrade
  &-item
    display: flex

    &:not(:last-child)
      margin-bottom: 16px

  &-icon
    margin: 0 10px 0 2px
    color: #BDBDBD

  &-content
    flex-grow: 1
    padding: 16px
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .15)

    border-radius: 10px

    background-color: white

    font-size: 0.875rem
    color: #8E8E8E

  &-title
    font-size: 1rem
    font-weight: bold

    text-align: center
    color: #333

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.vip-enter-active,
.vip-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)

.vip-enter,
.vip-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
